<ng-template #content let-modal>
  <div class="modal-header bg-dark">
    <h5 class="modal-title text-light">Ticket</h5>
    <button type="button" class="close text-light" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row justify-content-center">
      <div class="col-12">
        <iframe [src]="base64" *ngIf="base64" frameborder="0" width="100%" height="500px"></iframe>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-info" (click)="enviarMail()" *ngIf="false && Pedido?.cliente?.email">
      <i class="fas fa-paper-plane"></i> Enviar por Correo
    </button>
    <button type="button" class="btn btn-success" (click)="enviarWsp()" *ngIf="Pedido?.cliente?.telefono">
      <i class="fab fa-whatsapp"></i> Enviar por Whatsapp
    </button>
    <button type="button" class="btn btn-outline-danger" (click)="closeModal()">
      <i class="fas fa-times"></i> Cerrar
    </button>
  </div>
</ng-template>
